// Skjult fraværstitel ("Skjul titel" / default_private på fraværsårsager -> events.private).
//
// Reglen spejler backendens EventsQuery#select_title og SQL-funktionen event__json:
// titlen på et fravær vises kun for administratorer af skolen (can_manage_school,
// globale admins og skoler uden rettighedsstyring) og for brugeren selv. Alle andre ser blot "Fravær".
//
// De fleste endpoints maskerer allerede titlen på serveren. api.schools.availabilities.list
// (brugt til kollisions-advarsler og vikarlister) sender dog den rå titel uden private-flag,
// så her maskerer vi i frontend. Når private-flaget mangler i svaret, skjules titlen for en sikkerheds skyld.

const HIDDEN_ABSENCE_LABELS = {
  da: 'Fravær',
  nb: 'Fravær',
  en: 'Absence'
}

export function hiddenAbsenceLabel (locale) {
  const lang = typeof locale === 'string' ? locale.slice(0, 2).toLowerCase() : 'da'
  return HIDDEN_ABSENCE_LABELS[lang] || HIDDEN_ABSENCE_LABELS.da
}

// Samme logik som userHasPermission('can_manage_school') i bl.a. DCalendarShowEvent.vue
// og backendens ApplicationController#can?
export function canSeeHiddenAbsenceTitles (store, schoolId) {
  const user = store && store.state ? store.state.user : null
  if (!user) {
    return false
  }
  if (user.admin) {
    return true
  }
  const getters = store.getters || {}
  if (getters.isPermissionsActivatedForSchool === false) {
    return true
  }
  const memberships = user.memberships || []
  const membership = memberships.find(m => m && m.school_id * 1 === schoolId * 1)
  const permissions = membership ? membership.permissions : getters.userPermissions
  return Array.isArray(permissions) && permissions.indexOf('can_manage_school') > -1
}

export function isHiddenAbsenceTitle (event, canSeeAll, isOwn) {
  if (!event || event.event_type !== 'absence') {
    return false
  }
  if (canSeeAll || isOwn) {
    return false
  }
  return event.private !== false
}

function isOwnCalendarRow (row, user) {
  if (!row || !user) {
    return false
  }
  if (user.user_calendar_id && row.calendar_id === user.user_calendar_id) {
    return true
  }
  return !!(user.id && row.user_id && row.user_id === user.id)
}

// Maskerer fraværstitler i svaret fra api.schools.availabilities.list ([{calendar_id, user_id?, events: [...]}]).
// Muterer og returnerer det (nyparsede) array.
export function maskHiddenAbsenceTitlesInAvailability (rows, store, schoolId) {
  if (!Array.isArray(rows) || canSeeHiddenAbsenceTitles(store, schoolId)) {
    return rows
  }
  const user = store && store.state ? store.state.user : null
  const label = hiddenAbsenceLabel(store && store.getters ? store.getters.locale : null)
  rows.forEach(row => {
    const isOwn = isOwnCalendarRow(row, user)
    const events = row && Array.isArray(row.events) ? row.events : []
    events.forEach(event => {
      if (isHiddenAbsenceTitle(event, false, isOwn)) {
        event.title = label
      }
    })
  })
  return rows
}



// WEBPACK FOOTER //
// ./src/utils/hiddenAbsenceTitle.js